import type {VariantProps} from 'tailwind-variants';
import {tv} from 'tailwind-variants';
import {default as Carousel} from './Carousel.svelte';
import type {Class} from 'Catalyst/class';
import type {Writable} from 'svelte/store';

export const carouselTvProps = tv({
  slots: {
    base: `
      overflow-hidden
      relative
    `,
    container: `
      flex
      gap-[var(--carousel-slots-base-item-spacing)]
    `,
  },
  variants: {},
  defaultVariants: {},
});

export type CarouselTvProps = VariantProps<typeof carouselTvProps>;

export type CarouselProps = CarouselTvProps &
  Class &
  Omit<HTMLDivElement, 'role'> & {
    selectedIndex: number;
  };

export type CarouselStore = {
  selectedIndex: number;
  cardRegistry: Map<number, number>;
};

export type CarouselContext = {
  store: Writable<CarouselStore>;
  registerCard: () => {cardId: number; index: number};
  unregisterCard: (cardId: number) => void;
  scrollNext: () => void;
  scrollPrev: () => void;
};

export {Carousel};
